import React from 'react';
import PropTypes from 'prop-types';

import { Section, Container, Row, Column, H2, Image } from 'components/atoms';
import defaultBanner from '/assets/images/content-section/section-content-units.svg';

import './ContentSection.scss';
import { PSPMarkdownContent } from 'components/psp/PSPMarkdown';

const ContentSection = ({
	title,
	content,
	contentImage,
	ShowBackgroundImage = true,
	contentType,
	additionalProps,
	theme = 'light',
	showImageWidth = false,
}) => {
const color = theme === 'dark' ? 'white' : 'black' ;
	return (
		<Section
			className={`content-section ${theme} ${
				showImageWidth ? 'show-image-width' : ''
			} `}
		>
			<Container>
				<Row>
					<Column medium={12}>
						<div
							className={`content-section-container ${
								content && content.length === 2
									? 'two-columns'
									: ''
							}`}
						>
							{title && (
								<H2
									className="title"
									color={color}
								>
									{title}
								</H2>
							)}
							<Row className={`content ${contentType}`}>
								{content?.map((paragraph, index) => (
									<Column
										key={index}
										medium={12}
										large={
											contentType === 'row-type' ? 12 : 4
										}
										className="content-column"
									>
										<PSPMarkdownContent
											className="content-text"
											content={paragraph}
											additionalProps={{
												...additionalProps,
												paragraph: { color },
												heading: { color },
												anchor: { color },
											}}
										/>
									</Column>
								))}
							</Row>
							{ShowBackgroundImage && (
								<Image
									src={contentImage || defaultBanner}
									className={`${contentImage ? 'content-image' : 'content-section-background'}`}
									alt="content section background image"
								/>
							)}
						</div>
					</Column>
				</Row>
			</Container>
		</Section>
	);
};

ContentSection.propTypes = {
	title: PropTypes.string,
	content: PropTypes.arrayOf(PropTypes.string),
	image: PropTypes.string,
	ShowBackgroundImage: PropTypes.bool,
	contentType: PropTypes.string,
	theme: PropTypes.string,
	contentImage: PropTypes.string,
	additionalProps: PropTypes.object,
	showImageWidth: PropTypes.bool,
};

export default ContentSection;
